import {request} from "@/request/request";


// export default function getAllList(url) {
//     request({
//         method:'GET',
//         url:url,
//     }).then(res =>{
//         var data = res.data
//         console.log(data);
//     },err=>{
//         console.log(err)
//     })
// }

// export function ceshi(){
//     request({
//         method:'GET',
//         url:"/cultural/getcolumn",
//     }).then(res =>{
//         console.log(res)
//     },err=>{
//         console.log(err)
//     })
// }


export function getCloumnList(){
        request({
            method:'GET',
            url:"/acolumns",
        })

}



